// src/components/DynamicLegals.js
import React from "react";
import { useWebData } from "../../Context/webDataContext";
import { Link } from "react-router-dom";

const DynamicLegals = () => {
  const { getPoliciesData } = useWebData();
  // Only include policies that are not disabled
  const policies = getPoliciesData().filter((policy) => !policy.disabled);

  return (
    <div className="space-y-3">
      {policies.map((policy) => (
        <Link
          key={policy.id}
          to={`/policy/${policy.path}`}
          className="hover:text-[#08875D] transition-all duration-200 cursor-pointer block"
        >
          {policy.title}
        </Link>
      ))}
    </div>
  );
};

export default DynamicLegals;
